import { gql } from "@apollo/client";

export const GET_SCHEDULE_FILTER_OPTIONS = gql`
  query {
    getScheduleFilterOptions {
      branch_ids {
        id
        name
      }
      class_ids {
        id
        name
      }
      exam_types {
        id
        name
      }
    }
  }
`;
export const GET_EXAM_TYPES = gql`
  query {
    getExamTypes {
      id
      name
    }
  }
`;

export const GET_EXAM_SCHEDULES = gql`
  query GetExamSchedules(
    $filter: ScheduleFilterInput
    $page: Int
    $limit: Int
  ) {
    getExamSchedules(filter: $filter, page: $page, limit: $limit) {
      page
      limit
      total_count
      schedules {
        id
        schedule_name
        schedule_date
        academic_year_names
        branch_names
        board_names
        class_names
        deliverable
        batch_names
        created_at
        created_by
        created_by_id
        updated_at
        updated_by
        updated_by_id
        is_archived
        syllabus_public_pdf_url
      }
    }
  }
`;

export const GET_EXAM_SCHEDULE_ID = gql`
  query GetExamSchedule($id: ID!) {
    getExamSchedule(id: $id) {
      id
      scheduled_exam_name
      scheduled_exam_type_id
      scheduled_exam_type_name
      scheduled_date
      scheduled_start_time
      scheduled_end_time
      syllabus_public_pdf_url
      academic_year_ids
      academic_year_names
      college_ids
      college_names
      board_ids
      board_names
      class_ids
      class_names
      course_ids
      course_names
      batch_ids
      batch_names
      state_ids
      state_names
      status
      is_archived
      sort_order
      created_at
      created_by_id
      created_by_name
      updated_at
      updated_by_id
      updated_by_name
      subject_ids
      subject_names
    }
  }
`;

export const GET_SCHEDULE_SYLLABUS_CONTEXT = gql`
  query GetScheduleSyllabusContext($schedule_id: ID!) {
    getScheduleSyllabusContext(schedule_id: $schedule_id) {
      schedule_id
      schedule_name
      syllabus_public_pdf_url
      class_ids
      course_ids
      subjects {
        id
        name
        course_id
        course_name
        is_course_hierarchy
        is_program_hierarchy
      }
    }
  }
`;

export const GET_SCHEDULE_SYLLABUS_FULL_DATA = gql`
  query GetScheduleSyllabusFullData($schedule_id: ID!) {
    
    getScheduleSyllabusContext(schedule_id: $schedule_id) {
      schedule_id
      schedule_name
      syllabus_public_pdf_url
      class_ids
      course_ids
      subjects {
        id
        name
        course_id
        course_name
        is_course_hierarchy
        is_program_hierarchy
      }
    }

    getScheduleSyllabusDetails(schedule_id: $schedule_id) {
      schedule_id
      schedule_name
      syllabus_public_pdf_url
      subjects {
        id
        name
        course_id
        course_name
        is_course_hierarchy
        is_program_hierarchy
      }
      content_hierarchies {
        subject_id
        subject_name
        chapter_id
        chapter_name
        topic_id
        topic_name
        sort_order
        course_id
        course_name
        is_course_hierarchy
        is_program_hierarchy
      }
    }

  }
`;


export const GET_SCHEDULE_SYLLABUS_DETAILS = gql`
  query GetScheduleSyllabusDetails($schedule_id: ID!) {
    getScheduleSyllabusDetails(schedule_id: $schedule_id) {
      schedule_id
      schedule_name
      syllabus_public_pdf_url
      subjects {
        id
        name
        course_id
        course_name
        is_course_hierarchy
        is_program_hierarchy
      }
      content_hierarchies {
        subject_id
        subject_name
        chapter_id
        chapter_name
        topic_id
        topic_name
        sort_order
        course_id
        course_name
        is_course_hierarchy
        is_program_hierarchy
      }
    }
  }
`;

export const GET_DELIVERIES = gql`
  query GetDeliveries(
    $scheduleExamDeliveryId: String!
    $classIds: [String!]
    $collegeIds: [String!]
    $page: Float
    $limit: Float
  ) {
    getDeliveriesByScheduleExamDeliveryId(
      scheduleExamDeliveryId: $scheduleExamDeliveryId
      classIds: $classIds
      collegeIds: $collegeIds
      page: $page
      limit: $limit
    ) {
      deliveries {
        objectId
        label
        taskName
        chapterName
        startDateTime
        endDateTime
        createdby
        CreatedUserName
        showResults
        showReviseNow
        createdAt
        updatedAt

        # JSONB fields (clean arrays or undefined)
        Class {
          id
          name
        }
        Subject {
          id
          name
        }
        College {
          id
          name
        }
        Board {
          id
          name
        }
        State {
          id
          name
        }
        District {
          id
          name
        }
        Batch {
          id
          name
        }
        SubBatch {
          id
          name
        }
        Year {
          id
          name
        }
        RegistrationStatus {
          id
          name
        }
        DeliveryType {
          id
          name
        }
        NTSEExam {
          id
          name
        }
        CNAPSLevel {
          id
          name
        }
      }
      total
      page
      limit
      totalPages
    }
  }
`;

export const GET_COURSES_LIST = gql`
  query GetCoursesList($classId: String!) {
    getCoursesList(classId: $classId) {
      id
      name
      type
    }
  }
`;

export const GET_SUBJECTS_FOR_DROPDOWN = gql`
  query GetSubjectsForDropdown(
    $classId: String!
    $courseIds: [Int!]!
  ) {
    getSubjectsForDropdown(
      classId: $classId
      courseIds: $courseIds
    ) {
      id
      name
      courseId
      courseName
      is_course_hierarchy
      is_program_hierarchy
    }
  }
`;


export const GET_CHAPTERS_BY_SUBJECT = gql`
  query getChaptersBySubject(
    $classId: String!
    $courseIds: [Int!]!
    $subjectIds: [Int!]!
  ) {
    getChaptersBySubject(
      classId: $classId
      courseIds: $courseIds
      subjectIds: $subjectIds
    ) {
      id
      name
      subjectId
      subjectName
    }
  }
`;

export const GET_TOPICS_BY_SUBJECT_AND_CHAPTER = gql`
  query getTopicsBySubjectAndChapter(
    $classId: String!
    $courseIds: [Int!]!
    $subjectId: Int!
    $chapterIds: [Int!]!
  ) {
    getTopicsBySubjectAndChapter(
      classId: $classId
      courseIds: $courseIds
      subjectId: $subjectId
      chapterIds: $chapterIds
    ) {
      id
      name
      subjectId
      subjectName
      chapterId
      chapterName
    }
  }
`;

export const GET_CLASSES_LIST = gql`
  query GetClassesList {
    getClassesList {
      id
      name
    }
  }
`;
